export default __webpack_public_path__ + "static/media/h-rl-b.1168f436.png";